﻿import {$, $$, get, postDataJson, postDataText, show} from "@/Utils"
import {
    CalculateLeaseModel,
    LeaseCalculatorParameters,
    LeaseInformation,
    RentalCalculatorParameters,
    EventDetail
} from "@/interfaces"

/**
 * Tootekaardi liisingukalkulaator
 */
export function initLeaseCalculator() {
    addEventListenerToDropdownItems(true);
    addEventListenerToDropdownItems(false);
    initRentalCalculator();
}

function addEventListenerToDropdownItems(isInitialPaymentDropdown: boolean) {
    const type = isInitialPaymentDropdown ? "initial" : "period";
    const reverseType = isInitialPaymentDropdown ? "period" : "initial";
    
    $$(`.dropdown--${type}`).forEach(x => {
        x.addEventListener("valueChange", (e: CustomEvent<EventDetail>) => {
            const elem1 = parseInt(e.detail.value);
            const elem2 = parseInt($(`.dropdown--${reverseType} .dropdown__list-item--active`).getAttribute('value'));
            if (isInitialPaymentDropdown)
                updateLeaseInformation(elem2, elem1);
            else
                updateLeaseInformation(elem1, elem2);
        });
    });
}

const LeaseInformationCallback = (data: LeaseInformation) => {
    get("monthly-payment").textContent = data.minLease;
    const tooltipContainer = get("leaseInformation");
    if (tooltipContainer && tooltipContainer.hasAttribute("data-update-tooltip")) {
        const tooltip = tooltipContainer.querySelector(".tooltip__content");
        if(tooltip) {
            tooltip.innerHTML = data.latvianLeaseCalculatorTooltip;
        }
    }
}

function updateLeaseInformation(selectedPeriod: number, selectedInitialPayment: number) {
    window.leaseCalculatorParameters.selectedPeriod = selectedPeriod
    window.leaseCalculatorParameters.selectedInitialPayment = selectedInitialPayment
    const priorityElem = get("calculatorPriority");
    if (priorityElem) {
        window.leaseCalculatorParameters.calculatorPriority = parseInt((priorityElem as HTMLInputElement).value);
    }
    postDataJson(window.config.leaseInformationUrl, window.leaseCalculatorParameters, LeaseInformationCallback);
}

/**
 * Ostukorvi liisingukalkulaator (hetkel ainult BigBank)
 */
export function initBigBankLeaseCalculator() {
  $$("#down-payment-percents, #lease-periods").forEach((ddl: Element) => {
    ddl.addEventListener("valueChange", () => {
      const model: CalculateLeaseModel = {
        percent: parseInt((get("DownPaymentPercent") as HTMLInputElement).value),
        period: parseInt((get("BigBankLeasePeriod") as HTMLInputElement).value),
        price: parseFloat((get("AmountToPay") as HTMLInputElement).value)
      }
      const callback = (resp: string) => {
        const monthlyPayment = get("MonthlyPayment") as HTMLInputElement;
        monthlyPayment.value = resp;
      }
      postDataText(window.config.calculateBigBankLeaseUrl, model, callback)
    });
  });
}

export function initRentalCalculator(){
    $$(".rental-period-button")?.forEach((btn: Element) =>{
        btn.addEventListener("click", () => {
            $(".rental-period-button.button--active")?.classList.remove("button--active");
            btn.classList.add("button--active");
            const period = parseInt(btn.getAttribute("data-rental-period"));
            const code = (get("rental-code") as HTMLInputElement).value;
            const price = parseFloat((get("rental-price") as HTMLInputElement).value);
            const vatRate = parseFloat((get("rental-vat-rate") as HTMLInputElement).value);
            const data: RentalCalculatorParameters = {period: period, price: price, vatRate: vatRate, code: code};
            get("choose-rental-period")?.classList.remove("alert-validation--active", "input-validation-error");
            postDataText(window.config.getRentalMonthlyPaymentUrl, data, (response: string) => {
                const rentalPriceInput = get("rental-monthly-payment") as HTMLInputElement;
                rentalPriceInput.textContent = response;
                show(get("rental-monthly-payment-text"));
            });
        });
    });
}